import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { Threshold } from "PFTypes";
import React from "react";

import { Overbooking } from "../../../../../../types";
import css from "./overbookings_bar.module.scss";

export type OverbookingTooltipContentProps = {
  overbooking: Overbooking;
  threshold: Threshold | undefined;
};

export const OverbookingTooltipContent = ({
  overbooking,
  threshold
}: OverbookingTooltipContentProps): JSX.Element => {
  const { formatDate } = useDateFormatter();
  const { date, utilization, booked_minutes, available_minutes } = overbooking;
  const nominalAvailableHours = Math.round((booked_minutes + available_minutes) / 60);
  const bookedHours = Math.round(booked_minutes / 60);

  const hours = `${bookedHours}/${nominalAvailableHours}h`;
  const utilizationValue = `${Math.round(utilization * 100)}% - ${hours}`;

  return (
    <div className={css.tooltipContainer}>
      <div>{formatDate(date)}</div>
      {threshold && (
        <div className={css.tooltipOverbookingContainer}>
          <Icon name="warning" size="md" fill={threshold.color} />
          <Typography variant="bodyRegular" tag="span" className={css.tooltipOverbookingLabel}>
            {utilizationValue}
          </Typography>
        </div>
      )}
    </div>
  );
};
